<template>
    <svg
        version="1.1"
        id="Camada_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 200 200"
        style="enable-background: new 0 0 200 200"
        xml:space="preserve"
    >
        <path
            d="M173.7,136.9l-7.5-52.3c-1.3-8.8-8.6-15.6-17.3-16.3c-0.2-0.1-0.4-0.1-0.6-0.1h-14v-8.6c0-18.9-15.3-34.2-34.2-34.2
	S65.8,40.9,65.8,59.7v8.6H52.6c-0.1,0-0.3,0-0.4,0c-9.2,0.2-17.1,7.1-18.4,16.3l-7.5,52.3c-2.4,16.7,9.2,32.1,25.9,34.5
	c1.4,0.2,2.9,0.3,4.3,0.3h87c16.9,0,30.5-13.7,30.5-30.5C174,139.8,173.9,138.3,173.7,136.9z M106.5,107.6H94.3
	c-1.3,0-2.4,1.1-2.4,2.4v7.6H80.1c-15,0-27.2-12.2-27.2-27.2c0-1.1,0.1-2.2,0.2-3.3l1.7-13.8h11V90c-4.8,1.4-7.7,6.4-6.3,11.2
	s6.4,7.7,11.2,6.3c4.8-1.4,7.7-6.4,6.3-11.2c-0.9-3.1-3.3-5.5-6.3-6.3V73.3h58.5V90c-4.8,1.4-7.7,6.4-6.3,11.2
	c1.4,4.8,6.4,7.7,11.2,6.3c4.8-1.4,7.7-6.4,6.3-11.2c-0.9-3.1-3.3-5.5-6.3-6.3V73.3h11.9l1.7,13.8c1.8,14.9-8.8,28.5-23.7,30.3
	c-1.1,0.1-2.2,0.2-3.3,0.2h-11.8V110C108.9,108.6,107.8,107.6,106.5,107.6z M104.1,112.4v15.8h-7.3v-15.8H104.1z M131.7,101.2
	c1.4,0,2.5-1.1,2.5-2.5v-3.4c1.9,1.4,2.3,4,0.9,5.8c-1.4,1.9-4,2.3-5.8,0.9c-1.9-1.4-2.3-4-0.9-5.8c0.3-0.4,0.6-0.7,0.9-0.9v3.4
	C129.3,100.1,130.4,101.2,131.7,101.2z M68.3,101.2c1.4,0,2.5-1.1,2.5-2.5v-3.4c1.9,1.4,2.3,4,0.9,5.8c-1.4,1.9-4,2.3-5.8,0.9
	c-1.9-1.4-2.3-4-0.9-5.8c0.3-0.4,0.6-0.7,0.9-0.9v3.4C65.8,100.1,66.9,101.2,68.3,101.2L68.3,101.2z M70.7,59.7
	c0-16.1,13.1-29.3,29.3-29.3s29.3,13.1,29.3,29.3v8.6H70.7L70.7,59.7z M162.8,158c-4.9,5.6-11.9,8.8-19.3,8.8h-87
	c-14.1,0-25.6-11.5-25.6-25.6c0-1.2,0.1-2.4,0.3-3.6l7.5-52.3c0.9-5.9,5.3-10.6,11.2-11.8l-1.6,12.9c-2.2,17.6,10.3,33.6,27.9,35.8
	c1.3,0.2,2.6,0.2,3.9,0.2h11.8v8.2c0,1.3,1.1,2.4,2.4,2.4h12.2c1.3,0,2.4-1.1,2.4-2.4v-8.2h11.8c17.7,0,32.1-14.4,32.1-32.1
	c0-1.3-0.1-2.6-0.2-3.9L151,73.7c5.4,1.5,9.5,6,10.3,11.6l7.5,52.3C169.9,145,167.7,152.4,162.8,158z"
        />
    </svg>
</template>

<script>
    export default {
        name: 'BagIcon',
    };
</script>
